var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "modal_active_features",
        title: "Nouvelles fonctionnalités",
        scrollable: "",
        "hide-footer": "",
      },
    },
    [
      _c(
        "div",
        [
          _c("b-table", {
            attrs: {
              fields: _vm.fields,
              items: _vm.computedFeatures,
              busy: _vm.loadingList,
            },
            scopedSlots: _vm._u([
              {
                key: "table-busy",
                fn: function () {
                  return [
                    _c("div", { staticClass: "text-center my-2" }, [
                      _c("strong", [_vm._v("Chargement ...")]),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "cell(name)",
                fn: function (row) {
                  return [
                    _vm._v(
                      "\n    " +
                        _vm._s(_vm.$t("label." + row.item.common_name)) +
                        " "
                    ),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.needAsterisk(row.item.common_name),
                            expression: "needAsterisk(row.item.common_name)",
                          },
                        ],
                      },
                      [_vm._v("*")]
                    ),
                  ]
                },
              },
              {
                key: "cell(value)",
                fn: function (row) {
                  return [
                    _c("b-form-checkbox", {
                      attrs: { name: "check-button", switch: "" },
                      model: {
                        value: row.item.enable,
                        callback: function ($$v) {
                          _vm.$set(row.item, "enable", $$v)
                        },
                        expression: "row.item.enable",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.haveTemplateForm,
                  expression: "haveTemplateForm",
                },
              ],
              staticClass: "text-center",
            },
            [
              _vm._v(
                "\n    L'établissement a un template permettant de créer des formulaires d'entrée pour les futures résidents.\n  "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.haveTemplateForm,
                  expression: "!haveTemplateForm",
                },
              ],
              staticClass: "text-center",
            },
            [
              _vm._v("\n    L'établissement "),
              _c("b", [_vm._v("n'a pas")]),
              _vm._v(
                " de template permettant de créer des formulaires d'entrée pour les futures résidents."
              ),
              _c("br"),
              _vm._v(
                "\n    En activant '" +
                  _vm._s(_vm.$t("label.resident_entrance_form")) +
                  "' ou '" +
                  _vm._s(_vm.$t("label.resident_entrance_form_short_stay")) +
                  "', ce template sera créé automatiquement.\n  "
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text-center" }, [
            _vm._v(
              "\n    * Les éléments ne sont activable seulement si le profil résident est activé.\n  "
            ),
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-button",
            {
              attrs: { block: "", variant: "primary", disabled: _vm.loading },
              on: { click: _vm.updateFeatures },
            },
            [_vm._v(_vm._s(_vm.$t("btn.update")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }